export const modularLibraryEditorCopy = {
  en: {
    start: {
      prompt: 'Tap a shelf to edit it',
      badgeHint: 'Or tap the badge board to edit it.',
      browseHint: 'Pick a shelf from a list',
      wholeLibrary: 'For the whole library',
      shelvesGroup: 'Shelves and the badge board. Tap one to edit it.',
    },
    badges: {
      title: 'Badge board',
      open: 'Choose badges for your board',
      hint: 'Choose up to five earned badges to display.',
      count: '{{count}} of 5 selected',
      position: 'Position {{position}} on your board',
      empty: 'Earn badges through your reading journey, then choose which ones to display here.',
      limit: 'Your board is full. Remove a badge to choose another.',
      savedWithLibrary: 'Changes are saved when you tap Done in Edit library.',
      moveLeft: 'Move {{name}} left',
      moveRight: 'Move {{name}} right',
    },
    autoPopulate: 'Auto-populate',
    populationTitle: 'Preview layout',
    populationSummary: '{{bookCount}} books · {{collectibleCount}} collectibles',
    populationHint: 'Swipe to review. Nothing is saved until you apply.',
    populationOverflow: '{{count}} items remain in your collection.',
    populationApplied: 'Layout applied. Undo to restore your previous arrangement.',
    populationChanged: 'Your collection changed. Preview a new layout before applying.',
    swapLeft: 'Swap left',
    swapRight: 'Swap right',
    swapWith: 'Swap with {{name}}',
    swapAvailable: 'Use the swap arrows to exchange places with a neighbour.',
    swapUnavailable: 'These items can no longer swap places. Select an item to try again.',
    mergeShelves: 'Merge shelves',
    positionBlocked: 'No room to shift on this shelf.',
    arrangeShelf: 'Arrange shelf',
    arrangeShelfScope: 'All items on this shelf',
    align: { left: 'Left', center: 'Centre', right: 'Right', even: 'Even' },
    alignLabel: {
      left: 'Align all shelf items to the left',
      center: 'Centre all shelf items',
      right: 'Align all shelf items to the right',
      even: 'Space all shelf items evenly',
    },
    structurePreviewHint: 'Check the opening, then confirm.',
    shelfPosition: 'Position {{position}} of {{total}} in this row',
    noSuitableDivider: 'No dividers can be changed here.',
    title: 'Edit library',
    back: 'Back',
    undo: 'Undo',
    overviewHint: 'Tap a shelf or item to arrange it. Drag to explore.',
    moveTitle: 'Move item',
    moveToShelf: 'Move to another shelf',
    placeTitle: 'Place items',
    joinTitle: 'Join shelves',
    restoreTitle: 'Restore divider',
    leftBookcase: 'Left bookcase',
    centerBookcase: 'Centre bookcase',
    rightBookcase: 'Right bookcase',
    topShelf: 'Top shelf',
    upperShelf: 'Upper shelf',
    lowerShelf: 'Lower shelf',
    bottomShelf: 'Bottom shelf',
    shelfDescription: '{{section}} · {{level}}',
    emptyShelf: 'Empty shelf',
    shelfContents: '{{count}} items',
    selectShelf: 'Select shelf',
    browseItems: 'Items on this shelf',
    selectDivider: 'Choose a divider',
    contents: 'Contents',
    cancelJoin: 'Cancel preview',

    addItems: 'Add items',
    shelves: 'Shelves',
    browseShelves: 'Browse shelves',
    shelfSelected: 'Selected shelf',
    clearSelection: 'Clear selection',
    more: 'More',
    moreActions: 'Item actions',
    display: 'Display',
    cover: 'Cover',
    spine: 'Spine',
    customize: 'Customize',
    backToItems: 'Back to items',
    structureHint: 'Tap a divider to join shelves, or its outline to restore it.',
    joinPreview: 'Join these shelves',
    restorePreview: 'Restore this divider',
    join: 'Join shelves',
    restore: 'Restore divider',
    moveHint: 'Tap a destination shelf, then confirm the preview.',
    placementHint: 'Check the placement, then confirm.',
    cancelMove: 'Cancel move',
    cancelPlacement: 'Cancel placement',
    adjustPosition: 'Adjust position',
    shiftLeft: 'Shift left',
    shiftRight: 'Shift right',
    removeHint: 'The item stays in your collection. You can add it again.',
    chooseShelfHint: 'Tap a shelf to choose where to add your items.',
  },
  sk: {
    // Translation review: confirm the tone of the new shelf-selection guidance.
    start: {
      prompt: 'Ťuknutím na policu ju upravíte',
      badgeHint: 'Alebo ťuknite na nástenku odznakov.',
      browseHint: 'Vyberte policu zo zoznamu',
      wholeLibrary: 'Pre celú knižnicu',
      shelvesGroup: 'Police a nástenka odznakov. Ťuknutím vyberte, čo chcete upraviť.',
    },
    badges: {
      title: 'Nástenka odznakov',
      open: 'Vybrať odznaky na nástenku',
      hint: 'Vyberte až päť získaných odznakov, ktoré chcete vystaviť.',
      count: 'Vybrané: {{count}} z 5',
      position: 'Pozícia na nástenke: {{position}}',
      empty:
        'Získavajte odznaky na svojej čitateľskej ceste a potom si tu vyberte, ktoré vystavíte.',
      limit: 'Nástenka je plná. Ak chcete vybrať iný odznak, jeden odoberte.',
      savedWithLibrary: 'Zmeny sa uložia po klepnutí na Hotovo v úprave knižnice.',
      moveLeft: 'Presunúť {{name}} doľava',
      moveRight: 'Presunúť {{name}} doprava',
    },
    autoPopulate: 'Automaticky usporiadať',
    populationTitle: 'Náhľad rozloženia',
    populationSummary: 'Knihy: {{bookCount}} · Zberateľské predmety: {{collectibleCount}}',
    populationHint: 'Potiahnutím si pozrite návrh. Zmeny sa uložia až po potvrdení.',
    populationOverflow: 'V zbierke zostáva {{count}} predmetov.',
    populationApplied: 'Rozloženie bolo použité. Tlačidlom Späť obnovíte pôvodné usporiadanie.',
    populationChanged: 'Vaša zbierka sa zmenila. Pred potvrdením vytvorte nový náhľad.',
    swapLeft: 'Vymeniť vľavo',
    swapRight: 'Vymeniť vpravo',
    swapWith: 'Vymeniť s: {{name}}',
    swapAvailable: 'Šípkami na výmenu vymeníte miesta so susedným predmetom.',
    swapUnavailable:
      'Tieto predmety si už nemôžu vymeniť miesta. Vyberte predmet a skúste to znova.',
    mergeShelves: 'Spojiť police',
    positionBlocked: 'Na tejto polici nie je priestor na posunutie.',
    arrangeShelf: 'Usporiadať policu',
    arrangeShelfScope: 'Všetky predmety na tejto polici',
    align: { left: 'Vľavo', center: 'Stred', right: 'Vpravo', even: 'Rozložiť' },
    alignLabel: {
      left: 'Zarovnať všetky predmety na polici vľavo',
      center: 'Zarovnať všetky predmety na polici na stred',
      right: 'Zarovnať všetky predmety na polici vpravo',
      even: 'Rovnomerne rozložiť všetky predmety na polici',
    },
    structurePreviewHint: 'Skontrolujte otvor a potvrďte zmenu.',
    shelfPosition: 'Pozícia {{position}} z {{total}} v tomto rade',
    noSuitableDivider: 'Tu nemožno upraviť žiadnu priečku.',
    title: 'Upraviť knižnicu',
    back: 'Späť',
    undo: 'Späť',
    overviewHint: 'Ťuknite na policu alebo predmet. Potiahnutím sa rozhliadnite.',
    moveTitle: 'Presunúť predmet',
    moveToShelf: 'Presunúť na inú policu',
    placeTitle: 'Umiestniť predmety',
    joinTitle: 'Spojiť police',
    restoreTitle: 'Obnoviť priečku',
    leftBookcase: 'Ľavá knižnica',
    centerBookcase: 'Stred knižnice',
    rightBookcase: 'Pravá knižnica',
    topShelf: 'Vrchná polica',
    upperShelf: 'Horná polica',
    lowerShelf: 'Dolná polica',
    bottomShelf: 'Spodná polica',
    shelfDescription: '{{section}} · {{level}}',
    emptyShelf: 'Prázdna polica',
    shelfContents: '{{count}} predmetov',
    selectShelf: 'Vybrať policu',
    browseItems: 'Predmety na polici',
    selectDivider: 'Vybrať priečku',
    contents: 'Obsah',
    cancelJoin: 'Zrušiť náhľad',

    addItems: 'Pridať predmety',
    shelves: 'Police',
    browseShelves: 'Prehľad políc',
    shelfSelected: 'Vybraná polica',
    clearSelection: 'Zrušiť výber',
    more: 'Viac',
    moreActions: 'Možnosti predmetu',
    display: 'Vystavenie',
    cover: 'Obálka',
    spine: 'Chrbát',
    customize: 'Prispôsobiť',
    backToItems: 'Späť k predmetom',
    structureHint: 'Ťuknite na priečku na spojenie políc alebo na jej obrys na obnovenie.',
    joinPreview: 'Spojiť tieto police',
    restorePreview: 'Obnoviť túto priečku',
    join: 'Spojiť police',
    restore: 'Obnoviť priečku',
    moveHint: 'Ťuknite na cieľovú policu a potvrďte náhľad.',
    placementHint: 'Skontrolujte umiestnenie a potvrďte ho.',
    cancelMove: 'Zrušiť presun',
    cancelPlacement: 'Zrušiť umiestnenie',
    adjustPosition: 'Upraviť polohu',
    shiftLeft: 'Posunúť doľava',
    shiftRight: 'Posunúť doprava',
    removeHint: 'Predmet zostane vo vašej zbierke. Môžete ho znova pridať.',
    chooseShelfHint: 'Ťuknite na policu, na ktorú chcete pridať predmety.',
  },
  cs: {
    // Translation review: confirm the tone of the new shelf-selection guidance.
    start: {
      prompt: 'Klepnutím na polici ji upravíte',
      badgeHint: 'Nebo klepněte na nástěnku odznaků.',
      browseHint: 'Vyberte polici ze seznamu',
      wholeLibrary: 'Pro celou knihovnu',
      shelvesGroup: 'Police a nástěnka odznaků. Klepnutím vyberte, co chcete upravit.',
    },
    badges: {
      title: 'Nástěnka odznaků',
      open: 'Vybrat odznaky na nástěnku',
      hint: 'Vyberte až pět získaných odznaků, které chcete vystavit.',
      count: 'Vybráno: {{count}} z 5',
      position: 'Pozice na nástěnce: {{position}}',
      empty: 'Získávejte odznaky na své čtenářské cestě a potom si zde vyberte, které vystavíte.',
      limit: 'Nástěnka je plná. Chcete-li vybrat jiný odznak, jeden odeberte.',
      savedWithLibrary: 'Změny se uloží po klepnutí na Hotovo při úpravě knihovny.',
      moveLeft: 'Přesunout {{name}} doleva',
      moveRight: 'Přesunout {{name}} doprava',
    },
    autoPopulate: 'Automaticky uspořádat',
    populationTitle: 'Náhled rozložení',
    populationSummary: 'Knihy: {{bookCount}} · Sběratelské předměty: {{collectibleCount}}',
    populationHint: 'Potažením si prohlédněte návrh. Změny se uloží až po potvrzení.',
    populationOverflow: 'Ve sbírce zbývá {{count}} předmětů.',
    populationApplied: 'Rozložení bylo použito. Tlačítkem Zpět obnovíte původní uspořádání.',
    populationChanged: 'Vaše sbírka se změnila. Před potvrzením vytvořte nový náhled.',
    swapLeft: 'Vyměnit vlevo',
    swapRight: 'Vyměnit vpravo',
    swapWith: 'Vyměnit s: {{name}}',
    swapAvailable: 'Šipkami pro výměnu vyměníte místa se sousedním předmětem.',
    swapUnavailable:
      'Tyto předměty si již nemohou vyměnit místa. Vyberte předmět a zkuste to znovu.',
    mergeShelves: 'Spojit police',
    positionBlocked: 'Na této polici není prostor pro posunutí.',
    arrangeShelf: 'Uspořádat polici',
    arrangeShelfScope: 'Všechny předměty na této polici',
    align: { left: 'Vlevo', center: 'Střed', right: 'Vpravo', even: 'Rozložit' },
    alignLabel: {
      left: 'Zarovnat všechny předměty na polici vlevo',
      center: 'Zarovnat všechny předměty na polici na střed',
      right: 'Zarovnat všechny předměty na polici vpravo',
      even: 'Rovnoměrně rozmístit všechny předměty na polici',
    },
    structurePreviewHint: 'Zkontrolujte otvor a potvrďte změnu.',
    shelfPosition: 'Pozice {{position}} z {{total}} v této řadě',
    noSuitableDivider: 'Zde nelze upravit žádnou příčku.',
    title: 'Upravit knihovnu',
    back: 'Zpět',
    undo: 'Zpět',
    overviewHint: 'Klepněte na polici nebo předmět. Tažením se rozhlédněte.',
    moveTitle: 'Přesunout předmět',
    moveToShelf: 'Přesunout na jinou polici',
    placeTitle: 'Umístit předměty',
    joinTitle: 'Spojit police',
    restoreTitle: 'Obnovit příčku',
    leftBookcase: 'Levá knihovna',
    centerBookcase: 'Střed knihovny',
    rightBookcase: 'Pravá knihovna',
    topShelf: 'Vrchní police',
    upperShelf: 'Horní police',
    lowerShelf: 'Dolní police',
    bottomShelf: 'Spodní police',
    shelfDescription: '{{section}} · {{level}}',
    emptyShelf: 'Prázdná police',
    shelfContents: '{{count}} předmětů',
    selectShelf: 'Vybrat polici',
    browseItems: 'Předměty na polici',
    selectDivider: 'Vybrat příčku',
    contents: 'Obsah',
    cancelJoin: 'Zrušit náhled',

    addItems: 'Přidat předměty',
    shelves: 'Police',
    browseShelves: 'Přehled polic',
    shelfSelected: 'Vybraná police',
    clearSelection: 'Zrušit výběr',
    more: 'Více',
    moreActions: 'Možnosti předmětu',
    display: 'Vystavení',
    cover: 'Obálka',
    spine: 'Hřbet',
    customize: 'Přizpůsobit',
    backToItems: 'Zpět k předmětům',
    structureHint: 'Klepněte na příčku pro spojení polic nebo na její obrys pro obnovení.',
    joinPreview: 'Spojit tyto police',
    restorePreview: 'Obnovit tuto příčku',
    join: 'Spojit police',
    restore: 'Obnovit příčku',
    moveHint: 'Klepněte na cílovou polici a potvrďte náhled.',
    placementHint: 'Zkontrolujte umístění a potvrďte ho.',
    cancelMove: 'Zrušit přesun',
    cancelPlacement: 'Zrušit umístění',
    adjustPosition: 'Upravit polohu',
    shiftLeft: 'Posunout doleva',
    shiftRight: 'Posunout doprava',
    removeHint: 'Předmět zůstane ve vaší sbírce. Můžete ho znovu přidat.',
    chooseShelfHint: 'Klepněte na polici, na kterou chcete přidat předměty.',
  },
};
